import { Component, OnDestroy, OnInit } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor, process } from "@progress/kendo-data-query";
import { BehaviorSubject } from "rxjs";
import { isNullOrWhiteSpace } from "src/app/interfaces/string";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { SubSink } from "subsink";
import { ICirculationTemplate } from "../../interfaces";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services";
import { TemplateFacade } from "src/app/services/template.facade";

@Component({
    selector: "circ-new-from-template",
    templateUrl: "./new-from-template.component.html",
    styleUrls: ["./new-from-template.component.scss"],
    standalone: false
})
@LogClass({ source: "NewFromTemplateComponent" })
export class NewFromTemplateComponent implements OnInit, OnDestroy {
  private subscriptions = new SubSink();
  private logger: Logger;
  private filterValue: string = null;
  public templates: ICirculationTemplate[] = [];
  public loading = true;
  public gridView$ = new BehaviorSubject<GridDataResult>(null);

  constructor(
    private navigate: NavigationService,
    private templateFacade: TemplateFacade,
    private notificationFacade: NotificationFacade
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.logger.debug("ctor");
  }

  public ngOnInit(): void {
    this.subscriptions.sink = this.templateFacade.getTemplates().subscribe({
      error: (err) => {
        this.notificationFacade.showError(
          "Template could not be loaded. Please ask your Administrator for help. " +
            err.error.message
        );
        this.navigate.toCirculationOverview();
      },
      next: (t) => {
        this.logger.debug(`found ${this.templates.length} templates.`);
        this.templates = t;
        this.loading = false;
        this.loadGridView();
      }
    });
  }

  public onUse(t: ICirculationTemplate): void {
    this.loading = true;
    this.logger.debug(`creating circulation from template ${t.id}.`);
    this.subscriptions.sink = this.templateFacade.apply(t).subscribe((id) => {
      this.navigate.toCirculation(id);
    });
  }

  private loadGridView() {
    if (!this.templates) {
      this.logger.info("Data is null");
      this.gridView$.next(null);
      return;
    }

    this.gridView$.next(
      process(this.templates, {
        filter: this.getFilter(this.filterValue)
      })
    );
  }
  public onFilter(input: string): void {
    this.filterValue = input;
    this.loadGridView();
  }

  private getFilter(value: string): CompositeFilterDescriptor {
    if (isNullOrWhiteSpace(value)) {
      return null;
    }

    return {
      logic: "or",
      filters: [
        {
          field: "title",
          operator: "contains",
          value: value
        }
      ]
    };
  }
}
